var __WEBPACK_NAMESPACE_OBJECT__ = require("@redocly/react-dropdown-aria");;